// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"32b2283c3230c96e05e9","266":"782f6d7d63c6ea5a281b","757":"506ffb4d4594d56beed5","825":"df3e32aa33a256cc0a2f"}[chunkId] + ".css";
};